import { React, useState } from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import { Tooltip, Text, Tag } from '@netapp/bxp-design-system-react';
import { useTranslation, Trans } from "react-i18next";
import { allMenus as i18nNamespace } from "../../../../i18n/namespace";
import { isOrgInSafeMode } from "../../../identity-access-management/utils";
import RoleElevationChangeConfirmationModal from "./userMenu/components/RoleElevationChangeConfirmationModal";
import userMenuStyles from "../headerMenus/UserMenu.module.scss";

const SafeModeTag = () => {
    const { t } = useTranslation(i18nNamespace);
    const [showRoleElevationChangeConfirmation, setShowRoleElevationChangeConfirmation] = useState(false);
    const selectedOrg = useSelector(state => state.tenancy.selectedOrg);
    const isUserElevated = useSelector(state => state.tenancy?.user?.isUserElevated);
    const isSafeModeFeatureEnabled = useSelector((state) => state.features.active['NetApp.TenancyV4/safemode'] ?? false);
    const orgInSafeMode =  selectedOrg ? isOrgInSafeMode(selectedOrg["tags"]) : false;

    const OnConfirmationOk = () => {
        setShowRoleElevationChangeConfirmation(false);
        setTimeout(() => window.location.reload(), 1000);
    }

    return <>
        {isSafeModeFeatureEnabled && orgInSafeMode && !_.isUndefined(isUserElevated) &&
            <div onClick={() => setShowRoleElevationChangeConfirmation(!showRoleElevationChangeConfirmation)} className={userMenuStyles["safe-mode-tag"]}>
                <Tag level={12} style={{ marginLeft: 18 }}>
                    {isUserElevated ? t("elevated") : t("read_only")}
                    <Tooltip><Text><Trans i18nKey={isUserElevated ? "elevated_mode_tooltip":"read_only_tooltip"} t={t} components={{ strong: <strong /> }} /></Text>
                    </Tooltip>
                </Tag>
            </div>}
        {showRoleElevationChangeConfirmation &&
            <RoleElevationChangeConfirmationModal isUserRequestingElevation={!isUserElevated} OnConfirmationCancel={() => setShowRoleElevationChangeConfirmation(false)}
                OnConfirmationOk={() => OnConfirmationOk()} />}
    </>
}
export default SafeModeTag;